export const OPEN_HOURS_FLEXIBILITY = {
  FIXED: 'fixed',
  FLEXIBLE: 'flexible',
};
